import axios from 'axios';
import Vue from 'vue';

axios.defaults.baseURL = '';

class ApiCacheService {
  setHeaders(data = false, image = false, file = false) {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${Vue.prototype.$config.api_cache_key}`
    };

    if (data) {
      delete headersConfig['Content-Type'];
    }

    if (image) {
      headersConfig['Accept'] = 'image/png';
    }

    if (file) {
      headersConfig['Content-Type'] = 'application/pdf';
      headersConfig['Accept'] = 'application/pdf';
    }

    return headersConfig;
  }

  get(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${Vue.prototype.$config.api_cache}${url}`, { headers: this.setHeaders(), params: params })
        .then((response) => {
          resolve(response.data || response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  post(url, form, params = new URLSearchParams(), isFormData = false) {
    return new Promise((resolve, reject) => {
      axios.post(`${Vue.prototype.$config.api_cache}${url}`, form, { headers: this.setHeaders(isFormData), params: params })
        .then((response) => {
          resolve(response.data || response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  delete(url, params) {
    return new Promise((resolve, reject) => {
      axios.delete(`${Vue.prototype.$config.api_cache}${url}`, { headers: this.setHeaders(), params: params })
        .then((response) => {
          resolve(response.data || response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  put(url, form, params, isFormData = false) {
    return new Promise((resolve, reject) => {
      axios.put(`${Vue.prototype.$config.api_cache}${url}`, form, { headers: this.setHeaders(isFormData), params: params })
        .then((response) => {
          resolve(response.data || response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  downloadFile(url, params) {
    if (params.get('download')) {
      return new Promise((resolve, reject) => {
        axios.get(url, { headers: { 'responseType': 'blob' }, params: params, responseType: 'arraybuffer' })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        axios.get(url, { headers: this.setHeaders(), params: params })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  }

  downloadPublicFile(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${Vue.prototype.$config.api_cache}${url}`, { headers: { 'responseType': 'blob' }, params: params, responseType: 'arraybuffer' })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  readFile(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${Vue.prototype.$config.api_cache}${url}`, { headers: this.setHeaders(), params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

export default new ApiCacheService();
